<template lang="pug">
.ladder-header
  //- 用户头像
  .avatar
    img(:src="avatatImage")
    img.crown(src="https://m.hellobike.com/resource/gallery/407/_H5Nq4MZ_crown.png")
  .welcome-message
    .greeting {{ expiredUserInfo.title || '' }}
    //- 累计已省和会员状态
    .status-info
      .savings
        span {{ expiredUserInfo.discountAmountDesc || '' }}
        span {{ expiredUserInfo.totalDiscountAmount || 0 }}
        span 元
      .membership-status {{ expiredUserInfo.expiredDesc || '' }}
        span.days {{ expiredUserInfo.expirationDays || 0 }}天
</template>

<script>
export default {
  props: {
    expiredUserInfo: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {};
  },
  computed: {
    // 获取用户信息头像
    avatatImage() {
      if (this.expiredUserInfo.headPortrait) {
        return this.expiredUserInfo.headPortrait;
      }
      if (this.expiredUserInfo.sex === 0) {
        return 'https://m.hellobike.com/resource/gallery/407/HHfoGZsC_user_headimg_man.webp';
      }
      if (this.expiredUserInfo.sex === 1) {
        return 'https://m.hellobike.com/resource/gallery/407/2_-_Gnu-_user_headimg_woman.webp';
      }
      return 'https://m.hellobike.com/resource/helloyun/00061/VWRrB72ZME.png';
    },
  },
};
</script>

<style lang="less" scoped>
.ladder-header {
  display: flex;
  align-items: center;
  background-color: transparent;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  width: 100%;
  padding-bottom: 0.07rem;
  padding-left: 0.12rem;
  margin-top: 0.1rem;

  .avatar {
    width: 0.42rem;
    height: 0.42rem;
    border-radius: 50%;
    border: 2px solid transparent;
    background:
      linear-gradient(white, white) padding-box,
      linear-gradient(to right, #ffd571, #ffe194, #ffd571) border-box;
    display: flex;
    justify-content: center;
    align-content: center;
    position: relative;

    img {
      &:first-child {
        width: 0.38rem;
        height: 0.38rem;
        border-radius: 50%;
      }
    }

    .crown {
      position: absolute;
      top: -0.08rem;
      right: -0.07rem;
      width: 0.24rem;
      height: 0.22rem;
      flex-shrink: 0;
    }
  }

  .welcome-message {
    width: 100%;
    margin-left: 0.09rem;
    font-size: 0.2rem;

    .greeting {
      font-weight: 500;
      font-size: 0.14rem;
      color: #242729;
      margin-bottom: 0.02rem;
    }

    .status-info {
      font-size: 0.11rem;
      color: var(--Grey-1_, #242729);
      display: flex;
      align-items: flex-end;

      .savings {
        font-size: 0.11rem;
        font-weight: 400;

        > span {
          &:first-child {
            opacity: 0.6;
          }

          &:nth-child(2) {
            font-size: 0.15rem;
            font-weight: 500;
            font-family: 'DIN Alternate Bold', sans-serif;
            margin: 0 0.01rem;
            opacity: 1 !important;
          }

          &:last-child {
            opacity: 0.6;
          }
        }
      }

      .membership-status {
        font-weight: 500;
        margin-left: 0.08rem;
        display: flex;
        align-items: center;

        &::before {
          content: ' ';
          display: inline-block;
          width: 0.01rem;
          height: 0.08rem;
          margin-right: 0.06rem;
          background-color: #242729;
          opacity: 0.2;
        }

        .days {
          color: #ff5729;
        }
      }
    }
  }
}
</style>
